import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "components/Header/Header";
import { Footer } from "components/Footer/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "components/Sidebar/Navbar";
import Sidebar from "components/Sidebar/Sidebar";
import { useAuth } from "context/auth-context";
import Surveystreak from "components/Sidebar/Surveystreak/Surveystreak";
import Spinner from "components/Sidebar/Surveystreak/spinner";
// import ChatToggle from "components/Sidebar/Chatbot/ChatToggle";
import FeedbackWidget from "components/FeedbackWidget";
import { CookieBanner, CookieSettingsLink } from "components/core/CookieConsent/CookieBanner";

export const Layout = () => {
  const { auth } = useAuth();
  const [showSurveystreak, setShowSurveystreak] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const location = useLocation();
  const toggleSurveystreak = () => {
    setShowSurveystreak(!showSurveystreak);
  };

  const closesurveys = () => {
    setShowSurveystreak(false);
  };

  const normalizedPath = location.pathname.replace(/\/+$/, "");

  const hideFooterRoutes = ["/success", "/terminate", "/quota-full", "/security-terminate"];

  const hideFooter = hideFooterRoutes.includes(normalizedPath);
  return (
    <div>
      <header>
        {auth ? (
          <Navbar toggleSurveystreak={toggleSurveystreak} showSurveystreak={showSurveystreak} setShowSurveystreak={setShowSurveystreak} />
        ) : (
          <Header />
        )}
      </header>
      <main>
        {auth ? (
          <div onClick={closesurveys}>
            {showSurveystreak && <Surveystreak showSurveystreak={showSurveystreak} setShowSurveystreak={setShowSurveystreak} />}
            {showSpinner && <Spinner setShowSpinner={setShowSpinner} />}
            <Sidebar />
            {/* <div>{process.env.REACT_APP_ENV === "production" ? null : <ChatToggle />}</div> */}
            {/* The shell offsets content below the top bar and beside the sidebar. */}
            <div className="zs-app-main">
              <Outlet />
            </div>
            <ToastContainer />
          </div>
        ) : (
          <div className="zs-public-main">
            <Outlet />
          </div>
        )}
        {/* <div>{process.env.REACT_APP_ENV === "production" ? null : <ChatToggle />}</div> */}
        {/* Global feedback / support widget — available on every page, for guests and logged-in users */}
        <FeedbackWidget />
      </main>
      <footer>{!auth && !hideFooter && <Footer />}</footer>

      {/*
        Cookie banner and the persistent re-open control live HERE, not in Footer.
        Footer is hidden on /success, /terminate, /quota-full and
        /security-terminate — precisely the routed-participant pages — and for
        every signed-in user. A footer-hosted banner would therefore be invisible
        to most of the people who need to see it, and the re-open link would not
        exist on the pages where consent matters most.

        Neither blocks: no overlay, no focus trap, no scroll lock, so the
        landing -> survey -> redirect handoff is unaffected.
      */}
      <CookieBanner />
      <CookieSettingsLink />
    </div>
  );
};
